import { QueryClient, QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: false,
		},
	},
});

type Props = {
	children: ReactNode;
};

export const QueryClientProvider = ({ children }: Props) => {
	return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
};
